import * as moment from 'moment';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { CustomerType } from '../../customers/enums/customer-type.enum';
import { CustomerInfo } from '../../customers/models/customer-info.model';
import { Store } from '../../store/models/store.model';
import { QueueStatus } from '../enums/queue-status.enum';
import { QueueEvent } from './queue-event.model';

export class Queue {
  uuid: string;
  status: QueueStatus;
  store: Store;
  quota: number;
  dateTime: Date | string;
  user: CustomerInfo; // cliente consumidor que fez a própria reserva
  customerInfo: CustomerInfo; // estabelecimento que fez a própria reserva
  events: Array<QueueEvent>;
  queueNumber: string;
  priority: boolean;
  observation: string;
  customerNotes: string;

  // auxilia na tela
  customer: CustomerInfo;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.queueNumber && this.queueNumber.length > 0) {
      this.queueNumber = this.queueNumber.toString().slice(-3);
    }

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, QueueStatus);

      if (this.status == null) {
        this.status = QueueStatus.UNDEFINED;
      }
    }
    this.dateTime = moment(this.dateTime).toDate();

    // Para facilitar as visualizações na tela, seto no objeto auxiliar customer as infos do usuário
    if (this.user) {
      this.customer = new CustomerInfo(this.user);
    } else if (this.customerInfo) {
      this.customer = new CustomerInfo(this.customerInfo);
    } else if (this.uuid) {
      // Teoricamente não pode existir uma reserva sem usuário
      this.customer = new CustomerInfo({
        name: '(Cliente não encontrado)',
        phone: '',
      });
    }

    if (this.customer && !this.customer.type) {
      this.customer.type = this.uuid && this.user ? CustomerType.USER : CustomerType.PRE_USER;
    }
    if (this.events && this.events.length > 0) {
      let queueEvents: Array<QueueEvent> = [];
      this.events.forEach((q) => {
        queueEvents.push(new QueueEvent(q));
      });
      this.events = queueEvents;
    }
  }

  toJson(): any {
    const json: any = {
      uuid: this.uuid,
      store: { id: this.store.id },
      quota: Number(this.quota),
      priority: this.priority,
      observation: this.observation,
      customerNotes: this.customerNotes,
    };
    if (this.status) {
      json.status = this.status['code'];
    }
    if (this.user) {
      json.user = { id: this.user.id };
    } else if (this.customerInfo) {
      json.customerInfo = this.customerInfo;
      json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
    }
    return json;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/queue/models/queue.model.ts